import { ThunderDispatcher } from '@nu-art/thunderstorm-frontend/index';
export const dispatch_PathwayStateSelected = new ThunderDispatcher('__onPathwayStateSelected');
export const dispatch_PathwayTransitionSelected = new ThunderDispatcher('__onPathwayTransitionSelected');
export const dispatch_PathwayStateRealtimeChanges = new ThunderDispatcher('__onPathwayStateRealtimeChanges');
export const dispatch_FocusResolutionFunction = new ThunderDispatcher('__onFocusResolutionFunction');
//# sourceMappingURL=dispatchers.js.map